<template>
  <div class="template">
    <div class="search">
      <div class="search-center">
        <div class="search-item">
          <Input clearable
                 v-model="search.custTitle"
                 @on-enter="searchFn"
                 placeholder="客户名称"
                 style="width: 150px;"
          ></Input>
        </div>
        <div class="search-item">
          <Input clearable
                 v-model="search.userId"
                 placeholder="推荐人id"
                 style="width: 100px;"
          ></Input>
        </div>
        <div class="search-item">
          <Input clearable
                 v-model="search.custId"
                 on-enter="searchFn"
                 placeholder="客户id"
                 style="width: 100px;"
          ></Input>
        </div>
        <div class="search-item">
          <Input clearable
                 v-model="search.phone"
                 on-enter="searchFn"
                 placeholder="请输入手机号"
                 style="width: 150px;"
          ></Input>
        </div>
        <div class="search-item">
          <Select clearable
                  v-model="search.buyType"
                  placeholder="购买意向" style="width: 80px;"
          >
            <Option value="1">有</Option>
            <Option value="0">无</Option>
          </Select>
        </div>
        <div class="search-item">
          <Select clearable
                  v-model="search.custType"
                  placeholder="身份"          style="width: 80px;"
          >
            <Option value="30">老板</Option>
            <Option value="20">店长</Option>
            <Option value="10">员工</Option>
          </Select>
        </div>
        <div class="search-item">
          <Input clearable
                 v-model="search.remark"
                 placeholder="备注"         style="width: 100px;"
          ></Input>
        </div>
        <!-- 添加时间筛选 -->
        <div class="search-item">
          <DatePicker
              type="daterange"
              v-model="dateRange"
              placeholder="推荐日期"
              style="width: 200px"
              @on-change="handleDateChange"
          ></DatePicker>
        </div>

        <Button
            style="width: 80px;margin-right: 10px;margin-bottom:5px"
            type="primary"
            icon="ios-search"
            @click="searchFn"
        >查询
        </Button>
        <Button
            style="width: 80px;margin-right: 10px;margin-bottom:5px"
            type="primary"
            @click="saveOrUpdateCust"
        >新增
        </Button>
      </div>
    </div>
    <div class="table">
      <!-- PC端表格 -->
      <Table
          v-if="!isMobile"
          :columns="diyData.columns"
          :data="apiData.tableList"
      >
        <template slot="footer">
          <Page
              :total="apiData.total"
              show-total
              :page-size="search.pageSize"
              :current="search.pageNo"
              @on-change="pageChange"
              @on-page-size-change="pageSizeChange"
              class-name="footer-page"
              show-elevator
              show-sizer
          ></Page>
        </template>
      </Table>

      <!-- 移动端列表 -->
      <div v-else class="mobile-list">
        <div v-for="(item, index) in apiData.tableList" :key="index" class="mobile-item">
          <div class="mobile-item-header">
            <div class="mobile-item-title">{{ item.custTitle }}</div>
            <div class="mobile-item-actions">
              <Button size="small" type="primary" @click="editCustomer(item)">编辑</Button>
              <Button size="small" type="error" @click="deleteCustomer(item.id)">删除</Button>
            </div>
          </div>
          <div class="mobile-item-content">
            <div class="mobile-item-row">
              <span class="mobile-item-label">客户ID:</span>
              <span class="mobile-item-value">{{ item.custId }}</span>
            </div>
            <div class="mobile-item-row">
              <span class="mobile-item-label">手机号:</span>
              <span class="mobile-item-value">{{ item.phone }}</span>
            </div>
            <div class="mobile-item-row">
              <span class="mobile-item-label">推荐人:</span>
              <span class="mobile-item-value">
                <a @click="handleClickReferrerId(item.createrId)" style="color: #2D8cF0; cursor: pointer;">
                  {{ item.createrName }}
                </a>
              </span>
            </div>
            <div class="mobile-item-row">
              <span class="mobile-item-label">推荐人ID:</span>
              <span class="mobile-item-value">{{ item.userId }}</span>
            </div>
            <div class="search-item">
              <Select clearable
                      v-model="search.buyType"
                      placeholder="购买意向" style="width: 150px;"
              >
                <Option value="1">有</Option>
                <Option value="0">无</Option>
              </Select>
            </div>
            <div class="search-item">
              <Select clearable
                      v-model="search.custType"
                      placeholder="身份"          style="width: 150px;"
              >
                <Option value="30">老板</Option>
                <Option value="20">店长</Option>
                <Option value="10">员工</Option>
              </Select>
            </div>
            <div class="search-item">
              <Input clearable
                     v-model="search.remark"
                     placeholder="备注"         style="width: 150px;"
              ></Input>
            </div>
            <div class="mobile-item-row">
              <span class="mobile-item-label">推荐日期:</span>
              <span class="mobile-item-value">{{ item.custDate }}</span>
            </div>
            <div class="mobile-item-row">
              <span class="mobile-item-label">注册时间:</span>
              <span class="mobile-item-value">{{ item.createTime }}</span>
            </div>
            <div class="mobile-item-row">
              <span class="mobile-item-label">客户门头:</span>
              <span class="mobile-item-value">
                <img v-if="item.img" :src="item.img" style="width: 50px; height: 50px; cursor: pointer;"
                     @click="previewImage(item.img)"/>
                <span v-else>无图片</span>
              </span>
            </div>
          </div>
        </div>
        <div class="mobile-pagination">
          <Page
              :total="apiData.total"
              show-total
              :page-size="search.pageSize"
              :current="search.pageNo"
              @on-change="pageChange"
              @on-page-size-change="pageSizeChange"
              class-name="footer-page"
              show-elevator
              show-sizer
          ></Page>
        </div>
      </div>
    </div>

    <!-- 新增/修改客户模态框 -->
    <Modal
        v-model="diyDom.showModal"
        :title="editForm.id ? '修改客户' : '新增客户'"
        @on-ok="handleSave"
        @on-cancel="handleCancel"
        :width="isMobile ? '90%' : '500px'"
    >
      <Form :model="editForm" :label-width="80">
        <FormItem label="客户名称" required>
          <Input v-model="editForm.custTitle" placeholder="请输入客户名称"/>
        </FormItem>
        <FormItem label="客户ID">
          <Input v-model="editForm.custId" placeholder="请输入客户ID"/>
        </FormItem>
        <FormItem label="手机号">
          <Input v-model="editForm.phone" placeholder="请输入手机号"/>
        </FormItem>
        <FormItem label="推荐日期" required>
          <DatePicker type="date" v-model="editForm.custDate" placeholder="选择日期" style="width: 100%"/>
        </FormItem>
        <FormItem label="客户门头">
          <Upload
              :action="uploadUrl"
              :headers="headers"
              :on-success="handleUploadSuccess"
              :on-error="handleUploadError"
              :show-upload-list="false"
              style="display: inline-block"
          >
            <div v-if="editForm.img">
              <img :src="editForm.img" style="width: 100px; height: 100px;"/>
              <Button @click.stop="editForm.img = ''" size="small">删除</Button>
            </div>
            <div v-else
                 style="width: 100px; height: 100px; border: 1px dashed #ccc; display: flex; align-items: center; justify-content: center; cursor: pointer;">
              <Icon type="ios-camera" size="20"/>
            </div>
          </Upload>
        </FormItem>
      </Form>
    </Modal>

    <!-- 图片预览模态框 -->
    <Modal v-model="imagePreview.visible" footer-hide :title="imagePreview.title" :width="isMobile ? '90%' : '50%'">
      <div style="text-align: center;">
        <img :src="imagePreview.url" style="max-width: 100%; max-height: 80vh;"/>
      </div>
    </Modal>
  </div>
</template>

<script>
import { apiCustReferrerDelete, apiCustReferrerList, apiCustReferrerSave } from '@/api/cust-referrer.js'
import { getDateTime } from '@/libs/util'

export default {
  name: 'cust-referrer',
  data () {
    return {
      query: {},
      headers: {
        token: localStorage.getItem('token')
      },
      uploadUrl: process.env.VUE_APP_API_URL + '/upload-file',
      isMobile: false, // 添加移动端检测
      search: {
        custTitle: '',
        userId: '',
        custId: '',
        buyType: '', // 重置购买意向
        custType: '', // 重置身份
        remark: '', // 重置备注
        phone: '',
        custDate: '',
        dateStart: '',
        dateEnd: '',
        pageNo: 1,
        pageSize: 10,
        orderNum: '',
        dateRange: [] // 日期范围
      },
      diyDom: {
        showModal: false
      },
      editForm: {
        id: null,
        custTitle: '',
        custId: '',
        phone: '',
        custDate: '',
        img: ''
      },
      imagePreview: {
        visible: false,
        url: '',
        title: '图片预览'
      },
      diyData: {
        orderNo: '',
        columns: [
          {
            title: '客户名称',
            width: '200px',
            key: 'custTitle'
          },
          {
            title: '客户门头',
            width: '120px',
            render: (h, params) => {
              return h('img', {
                attrs: {
                  src: params.row.img
                },
                style: {
                  width: '50px',
                  cursor: 'pointer'
                },
                on: {
                  click: () => {
                    this.previewImage(params.row.img)
                  }
                }
              })
            }
          },
          {
            title: '客户用户ID',
            width: '150px',
            key: 'custId'
          },
          {
            title: '手机号',
            width: '150px',
            render: (h, params) => {
              return h('div', [
                h('p', params.row.phone)
              ])
            }
          },
          {
            title: '推荐人/ID',
            width: '140px',
            render: (h, params) => {
              return h('div', [
                h(
                  'a', // 改为 a 标签
                  {
                    style: {
                      color: '#2D8cF0',
                      cursor: 'pointer'
                    },
                    on: {
                      click: () => {
                        this.handleClickReferrerId(params.row.userId) // 绑定点击事件
                      }
                    }
                  },
                  params.row.createrName
                ),
                h('p', params.row.userId)
              ])
            }
          },
          {
            title: '身份',
            width: '100px',
            key: 'custTypeName'
          },
          {
            title: '购买意向',
            width: '100px',
            render: (h, params) => {
              const isEmphasized = params.row.buyTypeName === '有'
              return h('span', {
                style: {
                  color: isEmphasized ? '#2D8cF0' : 'inherit',
                  fontWeight: isEmphasized ? 'bold' : 'normal'
                }
              }, params.row.buyTypeName)
            }
          },
          {
            title: '备注',
            width: '200px',
            key: 'remark'
          },
          {
            title: '推荐日期/注册时间',
            width: '200px',
            render: (h, params) => {
              return h('div', [
                h('div', `${params.row.custDate}`),
                h('div', `${params.row.createTime}`)
              ])
            }
          },

          {
            title: '操作',
            width: '300px',
            fixed: 'right',
            render: (h, params) => {
              return h('div', [
                h('Button', {
                  props: {
                    size: 'small',
                    type: 'primary'
                  },
                  style: {
                    marginRight: '10px',
                    fontSize: '14px'
                  },
                  on: {
                    click: () => {
                      this.editCustomer(params.row)
                    }
                  }
                },
                '编辑'
                ),
                h('Button', {
                  props: {
                    size: 'small',
                    type: 'error'
                  },
                  style: {
                    fontSize: '14px'
                  },
                  on: {
                    click: () => {
                      this.deleteCustomer(params.row.id)
                    }
                  }
                },
                '删除'
                )
              ])
            }
          }
        ]
      },
      apiData: {
        total: 0,
        infor: null,
        tableList: []
      },
      dateRange: [] // 添加时间范围数据
    }
  },
  methods: {
    // 检测是否为移动端
    checkIsMobile () {
      this.isMobile = window.innerWidth < 768
    },
    // 分页
    pageChange (e) {
      this.search.pageNo = e
      this.getTableList()
    },
    handleClickReferrerId (userId) {
      if (!userId) {
        this.$Message.warning('该用户没有推荐人')
        return
      }

      this.search.userId = userId // 设置推荐人 ID 为搜索条件
      this.search.pageNo = 1 // 重置页码为第一页
      this.getTableList() // 调用查询方法
    },
    pageSizeChange (e) {
      this.search.pageSize = e
      this.search.pageNo = 1
      this.getTableList()
    },
    // 搜索
    searchFn () {
      this.search.pageNo = 1
      this.getTableList()
    },
    getTableList () {
      this.$store.commit('setSpinShow', true)
      var opt = { ...this.search }
      console.info(opt)
      apiCustReferrerList(opt).then((res) => {
        const {
          list,
          totalCount
        } = res.data
        list.forEach(item => {
          item.img = item.img ? item.img + '?x-oss-process=image/resize,m_fill,w_60' : ''
        })
        this.apiData.tableList = list
        this.apiData.total = totalCount
      }).finally(() => this.$store.commit('setSpinShow', false))
    },
    /**
     * 保存或修改
     */
    saveOrUpdateCust () {
      // 重置表单
      this.editForm = {
        id: null,
        custTitle: '',
        custId: '',
        phone: '',
        custDate: '',
        img: ''
      }
      this.diyDom.showModal = true
    },
    /**
     * 编辑客户
     */
    editCustomer (row) {
      this.editForm = {
        id: row.id,
        custTitle: row.custTitle,
        custId: row.custId,
        phone: row.phone,
        custDate: row.custDate,
        img: row.img
      }
      this.diyDom.showModal = true
    },
    /**
     * 保存客户信息
     */
    handleSave () {
      // 表单验证
      if (!this.editForm.custTitle) {
        this.$Message.error('请输入客户名称')
        return
      }
      if (!this.editForm.custDate) {
        this.$Message.error('请选择推广日期')
        return
      }
      // 格式化日期，只保留年月日
      const submitData = { ...this.editForm }
      if (this.editForm.custDate) {
        if (this.editForm.custDate instanceof Date) {
          // 如果是Date对象，格式化为YYYY-MM-DD
          submitData.custDate = this.editForm.custDate.getFullYear() + '-' +
              String(this.editForm.custDate.getMonth() + 1).padStart(2, '0') + '-' +
              String(this.editForm.custDate.getDate()).padStart(2, '0')
        } else if (typeof this.editForm.custDate === 'string') {
          // 如果是字符串，确保只保留日期部分
          submitData.custDate = this.editForm.custDate.split('T')[0].split(' ')[0]
        }
      }
      submitData.custDate = submitData.custDate + ' 00:00:00'
      if (submitData.img && submitData.img.includes('?')) {
        submitData.img = submitData.img.split('?')[0]
      }
      // 调用保存接口
      apiCustReferrerSave(submitData).then(res => {
        if (res.code === 200) {
          this.$Message.success(res.msg || '保存成功')
          this.diyDom.showModal = false
          this.getTableList() // 刷新列表
        } else {
          this.$Message.error(res.msg || '保存失败')
        }
      }).catch(err => {
        this.$Message.error('保存失败: ' + err.message)
      })
    },
    /**
     * 取消保存
     */
    handleCancel () {
      this.diyDom.showModal = false
    },
    /**
     * 删除客户
     */
    deleteCustomer (id) {
      this.$Modal.confirm({
        title: '确认删除',
        content: '确定要删除这个客户吗？',
        onOk: () => {
          apiCustReferrerDelete({ ids: id }).then(res => {
            if (res.code === 200) {
              this.$Message.success('删除成功')
              this.getTableList() // 刷新列表
            } else {
              this.$Message.error(res.msg || '删除失败')
            }
          }).catch(err => {
            this.$Message.error('删除失败: ' + err.message)
          })
        }
      })
    },
    /**
     * 上传成功回调
     */
    handleUploadSuccess (res, file) {
      if (res.code === 200) {
        this.editForm.img = res.data.fileUrl
        this.$Message.success('上传成功')
      } else {
        this.$Message.error(res.msg || '上传失败')
      }
    },
    /**
     * 上传失败回调
     */
    handleUploadError (error, file) {
      this.$Message.error('上传失败: ' + error)
    },
    /**
     * 预览图片
     * @param {string} url - 图片URL
     */
    previewImage (url) {
      if (url && url.includes('?')) {
        url = url.split('?')[0]
      }
      this.imagePreview.url = url
      this.imagePreview.visible = true
    },
    // 添加时间改变处理方法
    handleDate (date) {
      this.search.custDate = date
    },
    // 添加时间改变处理方法
    handleDateChange (dates) {
      if (dates.length === 2) {
        this.search.dateStart = dates[0] + ' 00:00:00'
        this.search.dateEnd = dates[1] + ' 23:59:59'
      } else {
        this.search.dateStart = ''
        this.search.dateEnd = ''
      }
    },
    // 重置搜索条件
    resetSearch () {
      this.dateRange = []
      this.search = {
        custTitle: '',
        phone: '',
        id: '',
        pageNo: 1,
        pageSize: 10,
        orderNum: '',
        createTimeBegin: '',
        createTimeEnd: ''
      }
      this.getTableList()
    }
  },
  mounted () {
    var search = sessionStorage.getItem('search') || ''
    if (search) {
      this.search = JSON.parse(search)
      sessionStorage.removeItem('search')
    }
    this.getTableList()
    // 检测是否为移动端
    this.checkIsMobile()
    // 监听窗口大小变化
    window.addEventListener('resize', this.checkIsMobile)
  },
  beforeDestroy () {
    // 移除事件监听器
    window.removeEventListener('resize', this.checkIsMobile)
  }
}
</script>

<style scoped lang="less">
.template {
  width: 100%;
  background: #fff;
  padding: 20px;
  box-sizing: border-box;
}

.button-border {
  margin-right: 10px;
}

// 移动端适配样式
@media screen and (max-width: 768px) {
  .template {
    padding: 10px;
  }

  .search-center {
    flex-direction: column;
    align-items: stretch;
  }

  .search-item {
    margin-bottom: 10px;
  }

  .search-item input,
  .search-item .ivu-select,
  .search-item .ivu-date-picker {
    width: 100% !important;
  }

  .search-item .ivu-btn {
    width: 100% !important;
    margin-right: 0 !important;
    margin-bottom: 5px !important;
  }

  // 移动端列表样式
  .mobile-list {
    width: 100%;
  }

  .mobile-item {
    border: 1px solid #dcdee2;
    border-radius: 4px;
    margin-bottom: 10px;
    padding: 10px;
    background: #fff;
  }

  .mobile-item-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-bottom: 10px;
    border-bottom: 1px solid #e8eaec;
    margin-bottom: 10px;
  }

  .mobile-item-title {
    font-size: 16px;
    font-weight: bold;
    color: #515a6e;
  }

  .mobile-item-actions .ivu-btn {
    margin-left: 5px;
  }

  .mobile-item-content {
    font-size: 14px;
  }

  .mobile-item-row {
    display: flex;
    margin-bottom: 8px;
  }

  .mobile-item-label {
    font-weight: bold;
    width: 80px;
    color: #515a6e;
  }

  .mobile-item-value {
    flex: 1;
    color: #666;
  }

  .mobile-pagination {
    margin-top: 20px;

    /deep/ .ivu-page-options {
      display: none;
    }
  }

  // 模态框适配
  /deep/ .ivu-modal {
    width: 90% !important;
  }

  /deep/ .ivu-modal-content {
    padding: 10px;
  }

  /deep/ .ivu-form-item-label {
    padding-bottom: 5px;
  }
}

@media screen and (max-width: 480px) {
  .mobile-item-label {
    width: 70px;
    font-size: 13px;
  }

  .mobile-item-value {
    font-size: 13px;
  }

  .mobile-item-title {
    font-size: 15px;
  }
}
</style>
